export default [
  ["bold", "italic", "underline", "link", "image", "video", "formula", { list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }]
  // ["link", "image", "video"],
  // [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
];
